$(function () {
	  $(".selectpicker").selectpicker();
	  
	  sessionStorage.clear()

	  // 中央元素尺寸跟隨視窗大小調整
	  function adjustScale() {
		const baseHeight = 750; // 1280*750
		const currentHeight = window.innerHeight;

		if (currentHeight < baseHeight) {
			const scale = currentHeight / baseHeight;
			$(".content-container").css({
				"transform": `scale(${scale})`,
			})
		}
	  }
	  // 初始化調整，若後續調整視窗大小，則重新調整
	  adjustScale();
	  $(window).on('resize', adjustScale);

})